module.exports = "/shifts/modal-sales-upload-d9b17f.html";